import { Injectable } from '@angular/core';
import { Response, Http } from "@angular/http";
import { AuthHttp } from "angular2-jwt/angular2-jwt";

import { UserService } from "./user.service";
import { AuthService } from "../../auth/auth.service";
import { LoadingSpinnerService } from "./loading-spinner.service";

import { PaymentTerm } from "../models/payment-term.model";

import 'rxjs/Rx';
import { Observable } from "rxjs/Observable";
import { Subject } from 'rxjs/Subject';

import { AppSettings } from 'app.settings'
import { HttpClient } from '@angular/common/http';


@Injectable()
export class PaymentTermService {
  private url: string = AppSettings.API_ENDPOINT + 'api/paymentsterms/';

  public typesChanged = new Subject();

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private userService: UserService,
    private loadingService: LoadingSpinnerService
  ) { }

  getPaymentTerms(): Observable<PaymentTerm[]> {
    //this.authService.reauthenticateIfTokenExpired();

    this.loadingService.displayLoadingSpinner();
    return this.http.get(this.url).map(
      (response: Response) => {
        let paymentTerms: PaymentTerm[] = (<any>response);
        paymentTerms = paymentTerms.map(
          cT => {
            // cT.createdByUserAccount = this.userService.getUser(cT.createdByUserAccountId);
            // cT.updatedByUserAccount = this.userService.getUser(cT.updatedByUserAccountId);
            return cT;
          }
        );
        return paymentTerms;
      }
    ).finally(() => this.loadingService.hideLoadingSpinner());
  }

  getPaymentTerm(id: number): Observable<PaymentTerm> {
    //this.authService.reauthenticateIfTokenExpired();

    this.loadingService.displayLoadingSpinner();
    return this.http.get(this.url + id).map(
      (response: Response) => {
        let paymentTerm: PaymentTerm = (<any>response);
        // paymentTerm.createdByUserAccount = this.userService.getUser(paymentTerm.createdByUserAccountId);
        // paymentTerm.updatedByUserAccount = this.userService.getUser(paymentTerm.updatedByUserAccountId);
        return paymentTerm;
      }
    ).finally(() => this.loadingService.hideLoadingSpinner());
  }

  addPaymentTerm(paymentTerm: PaymentTerm): Observable<Response> {
    //this.authService.reauthenticateIfTokenExpired();

    this.loadingService.displayLoadingSpinner();
    return this.http.post<Response>(
      this.url,
      paymentTerm
    ).finally(() => this.loadingService.hideLoadingSpinner());
  }

  updatePaymentTerm(paymentTerm: PaymentTerm): Observable<Response> {
    //this.authService.reauthenticateIfTokenExpired();

    this.loadingService.displayLoadingSpinner();
    return this.http.put<Response>(
      this.url + paymentTerm.id,
      paymentTerm
    ).finally(() => this.loadingService.hideLoadingSpinner());
  }

  deletePaymentTerm(paymentTerm: PaymentTerm): Observable<Response> {
    //this.authService.reauthenticateIfTokenExpired();

    this.loadingService.displayLoadingSpinner();
    return this.http.put<Response>(
      this.url + "Delete/" + paymentTerm.id,
      paymentTerm
    ).finally(() => this.loadingService.hideLoadingSpinner());
  }
}
